<div id="office-locations-main" data-cy="reports-config-container">
  <mat-grid-list cols="6" rowHeight="100%" style="height:100%;" data-cy="reports-config-grid">
    <mat-grid-tile colspan="2" data-cy="reports-config-left-tile">
      <mat-card appearance="outlined" style="width:100%; height:100%;" data-cy="reports-config-left-card">
        <div style="height: 100%; display: flex; flex-direction: column;" data-cy="reports-config-left-content">
          <span style="flex-basis: fit-content;" class="configuration-section-title" data-cy="reports-config-title">Reports</span>
          <div style="flex-basis: fit-content;" data-cy="reports-config-client-container">
            <app-tdo-dropdown placeholder="Practice (Licensee)"
                              [dataSource]="clientList"
                              dataSourceDisplayKey="Name"
                              [isObjectValue]="true"
                              [value]="selectedClient"
                              (selectionChange)="onChangeClient($event)"
                              data-cy="reports-config-client-dropdown">
            </app-tdo-dropdown>
          </div>
          <div style="flex-basis: fit-content;" data-cy="reports-config-location-container">
            <app-tdo-dropdown placeholder="Locations"
                              [dataSource]="locationList"
                              dataSourceDisplayKey="Name"
                              [isObjectValue]="true"
                              [value]="selectedLocation"
                              (selectionChange)="onChangeLocation($event)"
                              data-cy="reports-config-location-dropdown">
            </app-tdo-dropdown>
          </div>
          <div style="flex-basis: fit-content;" data-cy="reports-config-category-container">
            <app-tdo-dropdown placeholder="Select Category"
                              appearance="legacy"
                              [dataSource]="reportCategoryEnumItems"
                              [isObjectValue]="true"
                              dataSourceDisplayKey="ItemDisplayValue"
                              [value]="selectedEnumReportCategory"
                              (selectionChange)="onUserReportCategoryChange($event)"
                              data-cy="reports-config-category-dropdown">
            </app-tdo-dropdown>
          </div>
          <div *ngIf="blReportByCategorySelected" style="flex: 1; height: 30px;" data-cy="reports-config-report-select-container">
            <mat-form-field floatLabel="auto"
                            style="width: 100%; background-color: white; border-radius: 8px; height: 30px;"
                            data-cy="reports-config-report-field">
              <mat-label data-cy="reports-config-report-label">Select Report</mat-label>
              <mat-select #reports data-cy="reports-config-report-select">
                <mat-option (onSelectionChange)="onReportSelected(report,$event);"
                            *ngFor="let report of reportsByCategory; let i = index" [value]="report"
                            data-cy="reports-config-report-option-{{i}}">
                  {{report.ReportName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="reports-config-right-tile">
      <mat-card appearance="outlined" style="width:100%; height:100%;" data-cy="reports-config-right-card">
        <div style="height: 100%; width: 90%; max-width: 700px;" data-cy="reports-config-right-content">
          <span class="configuration-section-title" data-cy="reports-config-configuration-title">Report Configuration</span>
          <app-tdo-configuration-action-bar (newClick)="onNew($event)"
                                            (saveClick)="onSave() "
                                            data-cy="reports-config-action-bar"></app-tdo-configuration-action-bar>
          <mat-card-content style="height: 100%;" data-cy="reports-config-form-container">
            <div
              style="display: flex; flex-direction: column; width: 100%; height: 100%; max-height: 100%; overflow-y: hidden;"
              data-cy="reports-config-form">
              <app-tdo-input style='flex-basis: fit-content;' placeholder="Name "
                             [(ngModel)]="UserReport.ReportName"
                             [disabled]="!isNewReport"
                             data-cy="reports-config-name-input"></app-tdo-input>
              <app-tdo-input style='flex-basis: fit-content;' placeholder="Description "
                             [(ngModel)]="UserReport.Description"
                             [disabled]="!isNewReport"
                             data-cy="reports-config-description-input"></app-tdo-input>
              <app-tdo-dropdown placeholder="Category"
                                appearance="legacy"
                                [dataSource]="reportCategoryEnumItems"
                                [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"
                                [value]="getCategoryById(UserReport.enumReportCategoryID)"
                                (selectionChange)="onUserReportCategorySelect($event)"
                                [disabled]="!isNewReport"
                                data-cy="reports-config-form-category-dropdown">
              </app-tdo-dropdown>
              <app-tdo-dropdown placeholder="Class"
                                appearance="legacy"
                                [dataSource]="reportClassEnumItems"
                                [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"
                                [value]="getClassById(UserReport.enumReportClassID)"
                                (selectionChange)="onUserReportCategorySelect($event)"
                                disabled="true"
                                data-cy="reports-config-class-dropdown">
              </app-tdo-dropdown>
              <div style="width: 100%; display: flex;flex-direction: column;" data-cy="reports-config-letter-container">
                <span style="padding:5px 5px 0 0" data-cy="reports-config-letter-title">Substitute this Report with Letter Template</span>
                <div
                  style="width: 70%; display: flex;flex-direction: row; border-bottom: solid 1px var(--tdo-blue-light)"
                  data-cy="reports-config-letter-select-row">
                  <span style="width: 90%; padding-left: 5px; padding-top: 10px;" data-cy="reports-config-letter-value">{{this.LetterSubstitute}}</span>
                  <div style="padding-left: 15px; padding-top: 10px"
                       matTooltip="Select Letter Template"
                       (click)="openLetterTemplate()"
                       data-cy="reports-config-letter-select-button">
                    <mat-icon>settings_ethernet</mat-icon>
                  </div>
                </div>
                <div style="padding: 20px; padding-top:20px" *ngIf="this.selectedReport" data-cy="reports-config-letter-toggle-container">
                  <mat-slide-toggle [(ngModel)]="UserReport.isLetterTemplate" (change)="onLetterTemplateChange($event)" (toggleChange)="configurationService.setDirty();" data-cy="reports-config-letter-toggle">Use LetterTemplate</mat-slide-toggle>
                </div>
              </div>
            </div>
          </mat-card-content>
        </div>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>


